import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import { renderContactCard } from './utils'

const ClinicalCoordinatorWidget = (props) => {
	const { data } = props
	const { process } = data
	const { i18n } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			title={i18n`Clinical Coordinator`}
			collapsedLabel={process?.clinicCoordinator?.name}
			icon='users'
			expanded={false}
			expandable={!!process?.clinicCoordinator}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{renderContactCard(process?.clinicCoordinator || {}, i18n)}
		</ExpandableWidget>
	)
}

export default ClinicalCoordinatorWidget
